import { render, staticRenderFns } from "./AddCallQueue.vue?vue&type=template&id=6936ed80&"
import script from "./AddCallQueue.vue?vue&type=script&lang=js&"
export * from "./AddCallQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports